interface GetQueryStringsFromUrlReturnObject {
  search: string | null;
  hash: string | null;
}
/**
 * getQueryStringsFromUrl
 *
 * a function to get the search and the hash string from a url
 *
 * @param {string} url
 * @returns {GetQueryStringsFromUrlReturnObject}
 */
export function getQueryStringsFromUrl(url: string): GetQueryStringsFromUrlReturnObject {
  const returnObject: GetQueryStringsFromUrlReturnObject = {
    search: null,
    hash: null,
  };

  const search = url.split('?').at(1)?.split('#').at(0);

  if (search) {
    returnObject.search = search;
  }
  const hash = url.split('#').at(1);

  if (hash) {
    returnObject.hash = hash;
  }

  return returnObject;
}
